<script setup lang="ts">
  const filterItems = ['all', 'general', 'update', 'sale', 'events', 'community', 'maintenance'].map((name) => ({
    title: name,
    route: { name: 'news-list', params: { newsType: name } },
  }))
  const currentFilterName = ref('all')
</script>
<template>
  <FilterRouteBox v-model:title="currentFilterName" :items="filterItems" />
  <RouterView v-slot="{ Component, route }">
    <Transition appear mode="out-in" name="fade">
      <component :is="Component" :key="route.path" />
    </Transition>
  </RouterView>
</template>
